<template>
    <div id="affiliate">
        <a :href="affiliateLink" target=_blank v-if="affiliateIsOnSale">
          <img v-if="affiliateBanner" class="affiliate-banner" :src="affiliateBanner" alt="affiliate-banner">
          <span v-else>{{ affiliateModelName }}</span>
        </a>
    </div>
</template>

<script>
    // default is for Mavic Air 2
  const defaultAffiliate = {
    link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
    banner: require('@/assets/mavic_air_2_480_70.jpg'),
    modelName: 'DJI Mavic Air 2',
    discontinued: false,
  }
  const UNKNOWN_AIRCRAFT = 'UNKNOWN_AIRCRAFT';

  const affiliateByModel = {
    UNKNOWN_AIRCRAFT: defaultAffiliate,
    INSPIRE_1: {
      link: 'https://click.dji.com/AO-Knl38K9dIwFp3_44_?pm=link',
      banner: null,
      modelName: 'DJI Inspire 1',
      discontinued: true,
    },
    INSPIRE_1_PRO: {
      link: 'https://click.dji.com/AO-Knl38K9dIwFp3_44_?pm=link',
      banner: null,
      modelName: 'DJI Inspire 1 Pro',
      discontinued: true,
    },
    INSPIRE_1_RAW: {
      link: 'https://click.dji.com/AO-Knl38K9dIwFp3_44_?pm=link',
      banner: null,
      modelName: 'DJI Inspire 1 Raw',
      discontinued: true,
    },
    INSPIRE_2: {
      link: 'https://click.dji.com/AO-Knl38K9dIwFp3_44_?pm=link',
      banner: null,
      modelName: 'DJI Inspire 2',
      discontinued: false,
    },
    PHANTOM_3_PROFESSIONAL: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 3 Professional',
      discontinued: true,
    },
    PHANTOM_3_ADVANCED: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 3 Advanced',
      discontinued: true,
    },
    PHANTOM_3_STANDARD: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 3 Standard',
      discontinued: true,
    },
    Phantom_3_4K: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 3 4K',
      discontinued: true,
    },
    Phantom_3_SE: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 3 SE',
      discontinued: true,
    },
    PHANTOM_4: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 4',
      discontinued: true,
    },
    PHANTOM_4_PRO: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 4 Pro',
      discontinued: true,
    },
    PHANTOM_4_PRO_V2: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 4 Pro V2',
      discontinued: false,
    },
    PHANTOM_4_ADVANCED: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 4 Advanced',
      discontinued: false,
    },
    PHANTOM_4_RTK: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 4 RTK',
      discontinued: false,
    },
    P_4_MULTISPECTRAL: {
      link: 'https://click.dji.com/ADyC3uNip0nxl0xzEIYg6Q?pm=ad_image',
      banner: require('@/assets/phantom_4_480_70.jpg'),
      modelName: 'DJI Phantom 4 Multispectral',
      discontinued: true,
    },
    MATRICE_100: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 100',
      discontinued: false,
    },
    MATRICE_200: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 200',
      discontinued: true,
    },
    MATRICE_200_V2: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 200 V2',
      discontinued: true,
    },
    MATRICE_210: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 210',
      discontinued: true,
    },
    MATRICE_210_RTK: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 210 RTK',
      discontinued: true,
    },
    MATRICE_210_V2: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 210 V2',
      discontinued: true,
    },
    MATRICE_210_RTK_V2: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 210 RTK V2',
      discontinued: true,
    },
    MATRICE_300_RTK: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 300 RTK',
      discontinued: true,
    },
    MATRICE_600: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 600',
      discontinued: false,
    },
    MATRICE_600_PRO: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Matrice 600 Pro',
      discontinued: false,
    },
    A3: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Flight controller A3',
      discontinued: true,
    },
    N3: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Flight controller N3',
      discontinued: true,
    },
    MAVIC_AIR: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Mavic Air',
      discontinued: false,
    },
    MAVIC_AIR_2: {
      link: 'https://click.dji.com/AFBl6JiN-x6vl6MvR9ggBg?pm=ad_image',
      banner: require('@/assets/mavic_air_2_480_70.jpg'),
      modelName: 'DJI Mavic Air 2',
      discontinued: false,
    },
    MAVIC_PRO: {
      link: 'https://click.dji.com/ADbJ_Z4AqatA0S598jdmiw?pm=ad_image',
      banner: require('@/assets/mavic_2_480_60.jpg'),
      modelName: 'DJI Mavic Pro',
      discontinued: true,
    },
    MAVIC_2_PRO: {
      link: 'https://click.dji.com/ADbJ_Z4AqatA0S598jdmiw?pm=ad_image',
      banner: require('@/assets/mavic_2_480_60.jpg'),
      modelName: 'DJI Mavic 2 Pro',
      discontinued: false,
    },
    MAVIC_2_ZOOM: {
      link: 'https://click.dji.com/ADbJ_Z4AqatA0S598jdmiw?pm=ad_image',
      banner: require('@/assets/mavic_2_480_60.jpg'),
      modelName: 'DJI Mavic 2 Zoom',
      discontinued: false,
    },
    MAVIC_2: {
      link: 'https://click.dji.com/ADbJ_Z4AqatA0S598jdmiw?pm=ad_image',
      banner: require('@/assets/mavic_2_480_60.jpg'),
      modelName: 'DJI Mavic 2',
      discontinued: false,
    },
    MAVIC_2_ENTERPRISE: {
      link: 'https://click.dji.com/ADbJ_Z4AqatA0S598jdmiw?pm=ad_image',
      banner: require('@/assets/mavic_2_480_60.jpg'),
      modelName: 'DJI Mavic 2 Enterprise',
      discontinued: false,
    },
    MAVIC_2_ENTERPRISE_DUAL: {
      link: 'https://click.dji.com/ADbJ_Z4AqatA0S598jdmiw?pm=ad_image',
      banner: require('@/assets/mavic_2_480_60.jpg'),
      modelName: 'DJI Mavic 2 Enterprise Dual',
      discontinued: false,
    },
    SPARK: {
      link: 'https://click.dji.com/AM1bP38o4xwmFJKjN0VR?pm=link',
      banner: require('@/assets/spark_468_60.jpg'),
      modelName: 'DJI Spark',
      discontinued: true,
    },
    MAVIC_MINI: {
      link: 'https://click.dji.com/ANrerEN3mYcOW1lN3nns_A?pm=ad_image',
      banner: require('@/assets/mavic_mini_728_90.jpg'),
      modelName: 'DJI Mavic Mini',
      discontinued: false,
    },
  }

  export default {
    name: "Affiliate",
    data: () => ({
      aircraftModel: UNKNOWN_AIRCRAFT,
    }),
    methods: {
      updateAircraftModel(aircraftModel) {
        this.aircraftModel = aircraftModel ? aircraftModel : UNKNOWN_AIRCRAFT;
      }
    },
    computed: {
      affiliateLink: function () {
        return (affiliateByModel[this.aircraftModel] || defaultAffiliate).link;
      },
      affiliateBanner: function () {
        return (affiliateByModel[this.aircraftModel] || defaultAffiliate).banner;
      },
      affiliateModelName: function () {
        return (affiliateByModel[this.aircraftModel] || defaultAffiliate).modelName;
      },
      affiliateIsOnSale: function () {
        return !(affiliateByModel[this.aircraftModel] || defaultAffiliate).discontinued;
      },
    }
  }
</script>

<style scoped>
#affiliate {
  z-index: 20;
  color: white;
}

.affiliate-banner {
    vertical-align: middle;
}

@media screen and (min-width: 320px) and (max-width: 768px) {
    .affiliate-banner {
        width: 40%;
    }
}

@media screen and (min-width: 768px) and (max-width: 1350px) {
    .affiliate-banner {
        width: 60%;
    }
}

</style>
